import script from "./completionDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./completionDetails.vue?vue&type=script&setup=true&lang=ts"

import "./completionDetails.vue?vue&type=style&index=0&id=12114a8a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12114a8a"]])

export default __exports__